import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Branches from "./pages/Branches";
import Franchise from "./pages/Franchise";
import About from "./pages/About";
import Contact from "./pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App min-h-screen bg-[#FAF8F5] text-[#3E2723]">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/menu" element={<Menu />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/franchise" element={<Franchise />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#FAF8F5",
                            color: "#3E2723",
                            border: "1px solid #E8D8C8",
                            fontFamily: "Outfit, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
